import { Component, h } from "preact";
import TemplateController from "../../../shared/controller/template-controller";
import Uploader from "../../uploader";
import {
  ILabelOptionValue,
  IOption,
  IReactConfiguration,
} from "../../../typings";
import EventController from "../../../shared/controller/event-controller";
import OutputController from "../../../shared/controller/output-controller";
import UnitSystemController from "../../../shared/controller/unit-system-controller";
import SliderDiv from "../slider/slider-div";

interface IColorLabelOptionSingleProps {
  templateController: TemplateController;
}

export default class LabelColorTextComponent extends Component<
  IColorLabelOptionSingleProps,
  ILabelColorComponentState
> {
  componentDidMount(): void {
    const color: string = this.props.outputController.getValue([
      "label",
      "color-text",
    ]);
    this.setState({
      color,
    });

    const eventName: string = EventController.getSaveEventName([
      "label",
      "color-text",
    ]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const color: string = this.props.outputController.getValue([
          "label",
          "color-text",
        ]);
        this.setState({
          color,
        });
      });
  }

  render(): JSX.Element {
    return (
      <SliderDiv
        active
        config={this.props.conf}
        onLoad={() => {}}
        slider={
          this.props.option.attributes.slider
            ? this.props.option.attributes.slider.value
            : false
        }
        small={false}
      >
        {this.props.option.values.map(
          (value: ILabelOptionValue, index: number) => (
            <div
              key={index}
              className={
                "w-1/5 py-4 flex justify-center items-center cursor-pointer hover:bg-gray-light rounded-md border-blue border border-solid border-opacity-0 " +
                (this.state.color === value.value
                  ? "bg-blue-lighter border-opacity-100 "
                  : "")
              }
              data-code={value.value}
              onClick={() => {
                this.props.outputController.setValue(
                  ["label", "color-text"],
                  value.value,
                );
              }}
              title={value.meta.name}
            >
              <span
                className={
                  "h-10 w-10 lg:h-14 lg:w-14 rounded-full " +
                  (value.attributes.hex.value === "#FFFFFF"
                    ? " option__color--border"
                    : "")
                }
                style={{ backgroundColor: value.attributes.hex.value }}
                alt={value.meta.name}
              />

              {value.attributes.sparkling &&
                value.attributes.sparkling.value &&
                value.attributes.sparkling.value !== "" && (
                  <span className="option__color option__color--sparkling-color" />
                )}
            </div>
          ),
        )}
      </SliderDiv>
    );
  }
}

interface IColorLabelOptionSingleProps {
  main: Uploader;
  conf: IReactConfiguration;
  option: IOption;

  eventController: EventController;
  outputController: OutputController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
}

interface ILabelColorComponentState {
  color: string;
}
